module.exports = __webpack_public_path__ + "static/media/demo_2.ae84487f.mp4";